// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const GreenSwitch = styled.div`
    .pul-switch input:checked + .pul-switch__indicator {
        background-color: #6eb474;
    }
`;

export const StyledActions = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;
